import { addField } from "../../api/activosXreports";
import { activosXreportsContext } from "./activosXreportsContext"

const ActivosXreportsState = props => {

    const saveField = async (fieldToSave) => {
        console.log("fieldToSave");
        console.log(fieldToSave);
        let res = await addField(fieldToSave);
    }

    const getFieldsByReport = async (reportName) => {
        console.log("reportName");
        console.log(reportName);
        let res = await getFieldsByReport(reportName);
    }

    return <activosXreportsContext.Provider value={{saveField, getFieldsByReport}}>
        {props.children}
    </activosXreportsContext.Provider>

}

export default ActivosXreportsState;